import { Maybe } from 'maybeasy';
import * as React from 'react';
import { Link } from '../../../../../../Resource/Types';
import ModalStore from '../../../../../Modal/Store';
import CloneStore from '../../Clone/Store';
import CollaboratorAccessStore from '../../CollaboratorAccess/Store';
import { collaboratorAccessLink } from './CollaboratorAccessLink';
import { cloneLink } from './CloneLink';
import { editLink } from './EditLink';
import { participantAccessLink } from './ParticipantAccessLink';
import { previewLink } from './PreviewLink';
import { publishAndShareLink } from './PublishAndShareLink';
import { removeLink } from './RemoveLink';
import { editV2Link } from './EditV2Link';
import { manageCommunicationsLink } from './ManageCommunicationsLink';

export interface Props {
  id: number;
  name: string;
  shareModalStore: ModalStore;
  hideModalStore: ModalStore;
  cloneStore: CloneStore;
  collaboratorAccessStore: CollaboratorAccessStore;
  links: ReadonlyArray<Link>;
}

export const actionItems = ({
  id,
  name,
  shareModalStore,
  hideModalStore,
  cloneStore,
  collaboratorAccessStore,
  links,
}: Props): Array<Maybe<React.ReactNode>> => [
  editLink({ id, links }),
  editV2Link({ id }),
  previewLink({ id }),
  cloneLink({ id, name, cloneStore }),
  publishAndShareLink({ shareModalStore, links }),
  participantAccessLink({ id }),
  manageCommunicationsLink({ id }),
  collaboratorAccessLink({ collaboratorAccessStore, links }),
  removeLink({ hideModalStore, links }),
];
